import { render } from "./StyleBadge.vue?vue&type=template&id=36a24158&scoped=true&ts=true"
import script from "./StyleBadge.vue?vue&type=script&lang=ts"
export * from "./StyleBadge.vue?vue&type=script&lang=ts"

import "./StyleBadge.vue?vue&type=style&index=0&id=36a24158&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a24158"]])

export default __exports__